module.exports = __webpack_public_path__ + "img/checklist.1627a50c.svg";